var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiAndInternetService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wifi_And_Internet_Service",
    "data-name": "Wifi And Internet Service",
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 88,
    cy: 88,
    r: 88,
    fill: "rgba(214,233,255,0.7)",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "router_black_24dp_1_",
    "data-name": "router_black_24dp (1)",
    transform: "translate(48.645 48.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M0,0H70.165V70.165H0ZM0,0H70.165V70.165H0Z",
    transform: "translate(4.355 4.356)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M43.981,15H5V30.592H59.573V15ZM16.694,26.694H8.9V18.9h7.8Zm13.643,0h-7.8V18.9h7.8Zm13.643,0h-7.8V18.9h7.8Z",
    transform: "translate(7.152 36.133)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M53.675,7.678A24.378,24.378,0,0,1,70.047,14.3l3.118-3.118a27.3,27.3,0,0,0-38.981,0L37.3,14.3A24.378,24.378,0,0,1,53.675,7.678ZM40.811,17.423l3.118,3.118a14.131,14.131,0,0,1,19.49,0l3.118-3.118a17.889,17.889,0,0,0-25.727,0ZM65.369,41.981h-7.8V26.388h-7.8V41.981H10.8a7.819,7.819,0,0,0-7.8,7.8V65.369a7.819,7.819,0,0,0,7.8,7.8H65.369a7.819,7.819,0,0,0,7.8-7.8V49.777A7.819,7.819,0,0,0,65.369,41.981Zm0,23.388H10.8V49.777H65.369ZM14.694,53.675h7.8v7.8h-7.8Zm13.643,0h7.8v7.8h-7.8Zm13.643,0h7.8v7.8h-7.8Z",
    transform: "translate(1.356 1.356)",
    fill: "#12355f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiAndInternetService);
export default __webpack_public_path__ + "static/media/Wifi And Internet Service.89b8d98f50cc59ccc832218840751d86.svg";
export { ForwardRef as ReactComponent };